export default __webpack_public_path__ + "static/media/education_blue_bg.222ce621.jpeg";